import {
  Component, Inject, Input, OnInit, ChangeDetectorRef,
} from '@angular/core';
import { LikeService } from '../../../../services/like.service';

@Component({
  selector: 'ut-community-feed-item-like-btn',
  templateUrl: './community-feed-item-like-btn.component.html',
  standalone: false,
})

export class CommunityFeedItemLikeBtnComponent implements OnInit {
  @Input() likeable: any;
  @Input() showLiked: boolean;
  currentUser: any;

  constructor(
    @Inject('$analytics') private $analytics: any,
    @Inject('$scope') private $scope: ng.IScope,
    private LikeService: LikeService,
    @Inject('UserService') private UserService: any,
    @Inject('LightTesterErrorService') private LightTesterErrorService: any,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.UserService.me().then((res) => {
      if (res !== null) {
        this.currentUser = res.data;
      } else {
        this.currentUser = null;
      }
    });
  }

  trackLiking(options) {
    this.$analytics.eventTrack(options.action, { category: 'Likes', label: options.type });
  }

  toggleLike = () => {
    if (this.LightTesterErrorService.show()) return;

    if (this.likeable.current_user_permissions.like) {
      if (!this.likeable.likes.liked_by_current_user) {
        this.LikeService.like(this.likeable.type, this.likeable.id).then(this.updateLikeStats);
        this.trackLiking({ action: 'like', type: this.likeable.type });
      } else {
        this.LikeService.unlike(this.likeable.type, this.likeable.id).then(this.updateLikeStats);
        this.trackLiking({ action: 'unlike', type: this.likeable.type });
      }
    }
  };

  updateLikeStats = (likeResponse) => {
    if (likeResponse) {
      this.likeable.likes.count = likeResponse.data.likes.count;
      this.likeable.likes.liked_by_current_user = likeResponse.data.likes.liked_by_current_user;
      this.$scope.$emit('feedItemLiked', this.likeable);
    }
    this.cdr.detectChanges();
    return likeResponse;
  };
}
